import moment from 'moment';

export default function getISODateOrTodaysISODate(dateString: string | undefined) {
  return dateString ? moment(dateString).toISOString() : moment().toISOString();
}


export function getStartOfDayISODate(dateString: string) {
  return moment(dateString).startOf('day').toISOString();
}

export function getEndOfDayISODate(dateString: string) {
  return moment(dateString).endOf('day').toISOString();
}
